export function dateComparator(a, b) {
   function parseDate(dateStr) {
      const monthMap = {
         JAN: 0,
         FEB: 1,
         MAR: 2,
         APR: 3,
         MAY: 4,
         JUN: 5,
         JUL: 6,
         AUG: 7,
         SEP: 8,
         OCT: 9,
         NOV: 10,
         DEC: 11,
      };

      const day = parseInt(dateStr.substring(0, 2), 10);
      const month = monthMap[dateStr.substring(2, 5)];
      const year = parseInt(dateStr.substring(5, 7), 10) + 2000; // Adjust year for 2000s
      const timeStr = dateStr.substring(8);

      if (timeStr) {
         const [hours, minutes] = timeStr.split(':').map(Number);
         return new Date(year, month, day, hours, minutes);
      }

      return new Date(year, month, day);
   }

   const dateA = parseDate(a);
   const dateB = parseDate(b);

   return dateA - dateB;
}

export function handleKeyboardNavigation(updateSelectedRows) {
   return function onCellKeyDown(params) {
      const key = params.event.key;
      const currentRowIndex = params.node.rowIndex;
      let nextRowIndex;

      if (key === 'ArrowDown') {
         nextRowIndex = currentRowIndex + 1;
      } else if (key === 'ArrowUp') {
         nextRowIndex = currentRowIndex - 1;
      }

      if (nextRowIndex !== undefined) {
         const displayedRowCount = params.api.getDisplayedRowCount();
         if (nextRowIndex >= 0 && nextRowIndex < displayedRowCount) {
            params.api.forEachNode((node) => node.setSelected(false));

            const nextRowNode = params.api.getDisplayedRowAtIndex(nextRowIndex);
            if (nextRowNode) {
               nextRowNode.setSelected(true);
               params.api.ensureIndexVisible(nextRowIndex);
            }

            params.event.preventDefault();
         }

         updateSelectedRows();
      }
   };
}

export function createDragToSelectHandlers({
   isDraggingRef,
   startRowRef,
   updateSelectedRows,
   gridApiRef,
}) {
   function selectRowsInRange(start, end) {
      if (!gridApiRef) return;
      const min = Math.min(start, end);
      const max = Math.max(start, end);

      gridApiRef.forEachNode((node) => {
         node.setSelected(node.rowIndex >= min && node.rowIndex <= max);
      });
   }

   function onCellMouseDown(params) {
      isDraggingRef.current = true;
      startRowRef.current = params.node.rowIndex;

      document.addEventListener('mouseup', onMouseUp);
      params.event.preventDefault();
   }

   function onCellMouseOver(params) {
      if (isDraggingRef.current && startRowRef.current !== null) {
         const currentRowIndex = params.node.rowIndex;
         selectRowsInRange(startRowRef.current, currentRowIndex);
      }
   }

   function onMouseUp() {
      isDraggingRef.current = false;
      startRowRef.current = null;
      document.removeEventListener('mouseup', onMouseUp);
      updateSelectedRows();
   }

   return {
      onCellMouseDown,
      onCellMouseOver,
      onMouseUp,
   };
}

export function createFirstDataRenderedHandler(autoSizeColumns) {
   return function onFirstDataRendered(params) {
      if (autoSizeColumns) {
         const allColumnIds = params.columnApi
            .getAllColumns()
            .map((column) => column.colId);

         params.columnApi.autoSizeColumns(allColumnIds);
      }
   };
}

export function createRowClickHandler(updateSelectedRows, lastRowClickedRef) {
   return function handleRowClick(params) {
      const event = params.event;
      const rowIndex = params.node.rowIndex;

      const ctrlPressed = event.ctrlKey || event.metaKey;
      const shiftPressed = event.shiftKey;

      if (shiftPressed) {
         if (lastRowClickedRef.current !== null) {
            const min = Math.min(lastRowClickedRef.current, rowIndex);
            const max = Math.max(lastRowClickedRef.current, rowIndex);

            params.api.forEachNode((node) => {
               if (node.rowIndex >= min && node.rowIndex <= max) {
                  node.setSelected(true);
               }
            });
         }
         lastRowClickedRef.current = rowIndex;
      } else if (ctrlPressed) {
         const isSelected = params.node.isSelected();
         params.node.setSelected(!isSelected);
         lastRowClickedRef.current = rowIndex;
      } else {
         params.api.forEachNode((node) => node.setSelected(false));
         params.node.setSelected(true);
         lastRowClickedRef.current = rowIndex;
      }

      updateSelectedRows();
   };
}

export function navigateToNextCell(params) {
   const previousCell = params.previousCellPosition;
   const nextCell = params.nextCellPosition;

   if (previousCell?.rowIndex === 0 && params.key === 'ArrowUp') {
      return null;
   }

   return nextCell;
}
